var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgRotateLeft = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3.64035V7.51606C6.02497 7.77578 6.23894 7.97669 6.5 7.98553H10.46C10.66 7.98273 10.8391 7.86109 10.9153 7.6763C10.9915 7.49152 10.9501 7.27917 10.81 7.13648L9.35 5.6681C10.5703 4.31509 12.4311 3.73279 14.2062 4.14851C15.9812 4.56423 17.389 5.91206 17.88 7.66589C17.9422 7.87899 18.1378 8.02549 18.36 8.02549H19.36C19.5125 8.02629 19.6566 7.95613 19.75 7.8357C19.8414 7.71637 19.8778 7.56385 19.85 7.41617C19.263 4.88217 17.3165 2.88303 14.7969 2.22658C12.2774 1.57012 9.60128 2.36486 7.85 4.28963L6.85 3.29074C6.711 3.14007 6.49277 3.09183 6.3031 3.16984C6.11344 3.24785 5.99249 3.4356 6 3.64035ZM18 10.0133H6C4.89543 10.0133 4 10.9077 4 12.0111V20.0022C4 21.1056 4.89543 22 6 22H18C19.1046 22 20 21.1056 20 20.0022V12.0111C20 10.9077 19.1046 10.0133 18 10.0133ZM18 20.0022H6V12.0111H18V20.0022Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRotateLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/rotate-left.8cc44562.svg";
export { ForwardRef as ReactComponent };